import {clsx} from 'clsx';
import {twMerge} from 'tailwind-merge';
import React from 'react';

const PageContent = React.forwardRef(
	({className, noCenter, noPadding, children}, ref) => {
		return (
			<div
				ref={ref}
				className={twMerge(
					clsx(
						'overflow-auto flex flex-col',
						noCenter ? 'items-stretch' : 'items-center',
						!noPadding && 'px-5 py-5',
						'[&>*]:shrink-0',
					),
					className,
				)}
			>
				{children}
			</div>
		);
	},
);

PageContent.displayName = 'PageContent';

export default PageContent;
